import React, { useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, Badge, Avatar, Box, InputBase, Popper, Paper, ClickAwayListener, Modal, useMediaQuery, TextField, InputAdornment, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import profileImg from '../assests/profile.png';
import permission from '../assests/permision.png';
import logoutImg from '../assests/logout.png'
import bellIcon from '../assests/bellIcon.png';
import ChevronRight from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import UserProfile from "../profile/UserProfile";
import CrossIcon from '../assests/croosicon.png';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import NotificationLogo from '../assests/NotificationLogo.svg'
import { logout } from "../../redux/userSlice";
import { bellIconNotificationApi, readNotifcationApi } from "../../api";
import { useEffect } from "react";
import './Navbar.css';
import Loader from "../loader/Loader";
import InfiniteScroll from "react-infinite-scroll-component";
import configuration from "../../config/Config";

// modl
const MenuItemStyled = ({ text, onClick, imgSrc, isRed }) => (
  <Box
    onClick={onClick}
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '8px 16px',
      backgroundColor: '#FFF',
      color: isRed ? '#EA4335' : '#362B24',
      borderRadius: '8px',
      width: '100%',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#F5F5F5',
      },
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <img src={imgSrc} alt={text} style={{ width: 48, height: 48, marginRight: 20 }} />
      <Typography sx={{ fontSize: '14px' }}>{text}</Typography>
    </Box>
    <ChevronRight sx={{ color: isRed ? '#EA4335' : 'inherit' }} />
  </Box>
);


const routeToDisplayName = {
  'dashboard': 'Dashboard',
  'user-management': 'User Management',
  'vender-management': 'Vender Management',
  'all-order': 'All Orders',
  'content-moderation': 'Content Moderation',
  'report-analysis': 'Report & Analysis',
  'event-management': 'Event Management',
  'push-notification': 'Push Notification',
  'help-support': 'Help & Supports',
  'user-permission': 'User Permission',
  'payment-details': 'Payment Transection',
};

const formatLink = (link) => {
  if (routeToDisplayName[link]) {
    return routeToDisplayName[link];
  }
};

const Navbar = ({ OpenSidebar, isMdOrAbove, activeLink }) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.user?.user?.token);
  const user = useSelector((state) => state?.user?.user);
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const [notifcationList, setNotificationList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasUnreadNotifications, setHasUnreadNotifications] = useState(false);

  const isSmallScreen = useMediaQuery('(max-width:480px)');
  const isNotificationOpen = Boolean(notificationAnchorEl);

  const handleCloseNotification = () => {
    setNotificationAnchorEl(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleProfileClick = () => {
    setModalOpen(true);
    setOpen(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handlePermissionClick = () => {
    navigate('/user-permission');
    setOpen(false);
  };

  const handlePaymentClick = () => {
    navigate('/payment-details');
    setOpen(false);
  };

  const handleLogoutClick = () => {
    const isConfirmed = window.confirm('Are you sure you want to logout?');
    if (isConfirmed) {
      dispatch(logout());
      toast.success('Admin Logout');
    }
  };

  const handleBellIcon = async () => {
    try {
      const response = await bellIconNotificationApi({ token, currentPage });
      // console.log('Notification response:', response);
      setNotificationList((prevList) => [...prevList, ...response?.notifications]);
      setTotalPages(response?.totalPages);
      setCurrentPage(response?.currentPage);

      // Check if there are any unread notifications
      const unreadNotificationExists = response?.notifications.some(
        (notification) => notification.isRead === false
      );
      setHasUnreadNotifications(unreadNotificationExists);
    } catch (error) {
      toast.error(error?.error)
      console.error('Error fetching notifications:', error);
    }
  };

  // Mark all notifications as read
  const handleRead = async () => {
    try {
      const res = await readNotifcationApi({ token });
      toast.success(res?.message);

      // After marking as read, hide the notification dot
      setHasUnreadNotifications(false); 
    } catch (error) {
      toast.error(error?.message);
      console.log("Error marking as read:", error);
    }
  };

  useEffect(() => {
    handleBellIcon(currentPage);
  }, [currentPage]);

  const handleNotificationClick = async (event) => {
    setNotificationAnchorEl(notificationAnchorEl ? null : event.currentTarget);
    // If the bell icon is clicked and there are unread notifications, mark them as read
    if (hasUnreadNotifications) {
      await handleRead();
    }
  };
  
  
  const loadMoreTickets = () =>{
    if(currentPage<totalPages){
      setCurrentPage((prevPage) => prevPage + 1);
    }
}
  const hasMoreTickets = currentPage < totalPages;

  return (
    <>
      <div style={{ marginTop: '20px' }}>
        <Toolbar>
          {/* Hamburger menu for small screens */}
          {!isMdOrAbove && (
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ display: { xs: 'block', transition: 'all 0.3s' } }}
              onClick={() => OpenSidebar()}
              className="hamburger-menu"
            >
              <MenuIcon />
            </IconButton>
          )}

          {/* Dashboard text */}
          <Typography
            className="srchNab"
            sx={{
              display: { xs: 'none', sm: 'block' },
              marginLeft: { sm: '270px', lg: '350px' },
              fontSize: { sm: '20px', md: '28px' },
              fontWeight: '700',
              marginRight: '20px',
              '@media (max-width: 600px)': {
                display: 'none !important',
                marginLeft: '350px !important',
              },
              '@media (max-width: 800px)': {
                marginLeft: '120px !important',
              },
              '@media (max-width: 1024px)': {
                marginLeft: '60px !important',
              },
              '@media (max-width: 1200px)': {
                marginLeft: '320px',
              },
            }}
          >
            {formatLink(activeLink) || 'Dashboard'}
          </Typography>

          {/* Spacer */}
          <div style={{ flexGrow: 1 }} />

          {/* Notification Icon */}
          <IconButton size="large" aria-label="show notifications" color="inherit" onClick={handleNotificationClick}>
            <Badge
              color="error"
              variant="dot"
              invisible={!hasUnreadNotifications} // Hide the yellow dot if no unread notifications
              sx={{
                '& .MuiBadge-dot': {
                  backgroundColor: '#FFC107', // Yellow dot color
                  height: '10px',
                  width: '10px',
                  borderRadius: '50%',
                },
              }}
            >
              <Avatar src={bellIcon} />
            </Badge>
          </IconButton>

          {/* Notification Menu */}
          <Menu
            anchorEl={notificationAnchorEl}
            open={isNotificationOpen}
            onClose={handleCloseNotification}
            MenuListProps={{
              'aria-labelledby': 'notification-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                borderRadius: '25px',
              },
            }}
          >
            <div
              onClick={handleCloseNotification}
              style={{
                width: '260px',
                borderRadius: '25px',
                minHeight: '280px',
                flexWrap: 'wrap',
                marginLeft: '10px',
                paddingRight: '10px',
              }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography
                  id="modal-title"
                  sx={{
                    fontSize: '16px',
                    color: '#362B24',
                    fontWeight: '700',
                    fontFamily: 'Heebo',
                    marginTop: '10px',
                  }}
                >
                  Notification
                </Typography>
                <IconButton>
                  <img
                    src={CrossIcon}
                    alt="Cross"
                    style={{
                      height: isSmallScreen ? '20px' : '20px',
                      width: isSmallScreen ? '20px' : '20px',
                    }}
                  />
                </IconButton>
              </Box>

              <div className="whole-container-list-bellIcon" id="scrollableDiv">
              <InfiniteScroll
                dataLength={notifcationList.length}
                next={loadMoreTickets}
                hasMore={hasMoreTickets}
                loader={<Loader variant="notification" />}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>You have seen it all</b>
                  </p>
                }
                scrollableTarget="scrollableDiv"
                key={notifcationList.length}
              >
                  {notifcationList.length > 0 ? (
                    notifcationList.map((item) => (
                      <div className="belIcon-list-container" key={item?._id}>
                        <div>
                          <img src={NotificationLogo} className="logo-belIcon" />
                        </div>
                        <div className="belIcon-text-list">
                          <div className="time-txt">
                            <div style={{ wordBreak: 'break-word' }}>{item?.type || 'N/A'}</div>
                            <div>
                              {item?.createdAt
                                ? new Date(item?.createdAt || '-').toLocaleDateString('en-US', {
                                    month: '2-digit',
                                    day: '2-digit',
                                    year: 'numeric',
                                  })
                                : ''}
                            </div>
                          </div>
                          <div style={{ wordBreak: 'break-word' }}>
                            {item?.payload?.notification || 'N/A'}
                          </div>
                          <hr />
                        </div>
                      </div>
                      
                    ))
                  ) : (
                    <div style={{ textAlign: 'center', fontFamily: 'Heebo' }}>No Data Found</div>
                  )}
                    </InfiniteScroll>
        
              </div>
            </div>
          </Menu>

          {/* Profile Section */}
          <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={handleProfileMenuOpen}>
            <IconButton edge="end" aria-label="account of current user" aria-haspopup="true" color="inherit">
              <Avatar
                alt={user?.firstName || 'User Avatar'}
                src={user?.picture ? `${configuration.cdnFront}/${user.picture}` : undefined}
              >
                {!user?.picture && (user?.firstName?.charAt(0)?.toUpperCase() || '?')}
              </Avatar>
            </IconButton>
            <div style={{ marginLeft: '10px', cursor: 'pointer' }}>
              <div style={{ color: '#333', fontWeight: '600' }}>
                {user?.firstName || ''}&nbsp;{user?.lastName || ''}
              </div>
              <div style={{ color: '#999' }}>{user?.email || ''}</div>
            </div>
            <IconButton edge="end" aria-label="account of current user" aria-haspopup="true" color="inherit">
              <ExpandMoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>

      {/* Profile Menu Popper */}
      <Popper open={open} anchorEl={anchorEl} placement="bottom-start">
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper sx={{ width: '300px', borderRadius: '24px', padding: '8px', boxShadow: 24 }}>
            <MenuItemStyled text="Manage Profile" onClick={handleProfileClick} imgSrc={profileImg} />
            {user?.role === 3 && (
              <MenuItemStyled text="User Permission" onClick={handlePermissionClick} imgSrc={permission} />
            )}
            <MenuItemStyled text="Logout" onClick={handleLogoutClick} imgSrc={logoutImg} isRed />
          </Paper>
        </ClickAwayListener>
      </Popper>

      {/* User Profile Modal */}
      <UserProfile open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default Navbar;
